import * as React from "react";

import { faArrowUpRightFromSquare } from "@fortawesome/pro-regular-svg-icons";
import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconPreview: React.FC<Omit<MprcIconFaProps, "icon">> = ({ size = "sm", ...rest }) => {
    return <MprcIconFa {...rest} size={size} icon={faArrowUpRightFromSquare} />;
};
